export default {
  props: {
    hostingid: {
      type: [String, Number],
      required: true,
    }
  },
  data () {
    return {
      password: {
        currentPassword: '',
        newPassword: '',
        passwordConfirmation: '',
      },
      loading: false,
      showPass: false,
      showNewPass: false,
      showPopover: false,
      showProtectHint: false,
      showGuessHint: false,
    }
  },
  methods: {
    setPassword (pass) {
      this.password.newPassword = pass
      this.password.passwordConfirmation = pass
    },
    async changePassword () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      this.loading = true
      try {
        const message = await this.setHostingPassword(this.password.newPassword)
        this.reportSuccess(message)
      } catch (err) {
        this.reportError(err)
      }
      this.loading = false
      this.reset()
    },
  }
}
